module.exports = __webpack_public_path__ + "2cb5571b022187b27a53d6cc161c54f5.svg";